import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Customerinvoices } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerInvoicesService {

  constructor(private common: CommonService, private httpClient: HttpClient) { }
  carrierInvoiceDatasource = new BehaviorSubject<any>({});
 
 
  // getAll(): Observable<Customerinvoices[]> {
  //   return this.httpClient.get<Customerinvoices[]>(this.common.getApiAddress() + "/customerinvoices")
  //     .pipe(
  //     map<Customerinvoices[], Customerinvoices[]>(r => {
  //         return r;
  //       }),
  //       catchError(e => {
  //         return this.common.handleError("Client get failed", e);
  //       })
  //     );
  // }

  getAll(status: string,pageNumber: number, pageSize: number): Observable<any[]> {

    let url = this.common.getApiAddress();

    if (status == undefined || status == null) {
      url = url + "/CustomerInvoices?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    } else {
      url = url + "/CustomerInvoices?status=" + status + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    }

    return this.httpClient.get<Customerinvoices[]>(url)
      .pipe(
        map<Customerinvoices[], Customerinvoices[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("CustomerInvoices get failed", e);
        })
      );
  }

  create(data: any): Observable<any> {
    return this.httpClient.post<any>(this.common.getApiAddress() + "/customerinvoices", data)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create client failed", e);
        })
      );
  }

  get(id: number, action: string): Observable<any> {
    return this.httpClient.get<Customerinvoices[]>(this.common.getApiAddress() + "/customerinvoices/" + id.toString() + "?action=" + action)
      .pipe(
        map<any, any>(
          r => {
            return r;
          }
        ),
        catchError(
          e => {
            return this.common.handleError("Carrier invoice file get failed", e);
          }
        )
      );
  }

  getTransaction(clientId: number, invoiceStartDate: any, invoiceEndDate: any, action: string, customerInvoiceId: number, pageNumber: number, pageSize: number): Observable<any> {
    return this.httpClient.get<Customerinvoices[]>(this.common.getApiAddress() + "/CustomerInvoices/get-Transactions?" + "clientId=" + clientId + "&invoiceStartDate=" + invoiceStartDate + "&invoiceEndDate=" + invoiceEndDate + "&action=" + action + "&customerInvoiceId=" + customerInvoiceId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize)
      .pipe(
        map<any, any>(
          r => {
            return r;
          }
        ),
        catchError(
          e => {
            //debugger;
            return this.common.handleError("Add trasaction get failed", e);
          }
        )
      );
  }

  PostTransaction(data: any): Observable<any> {
    return this.httpClient.post<any>(this.common.getApiAddress() + "/CustomerInvoices/Save", data)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Post customer invoices failed", e);
        })
      );
  }


  generateInvoice(data: any): Observable<any> {
    return this.httpClient.post<any>(this.common.getApiAddress() + "/customerinvoices/GenerateInvoice", data)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Generating Invoicegot failed due to an issue", e);
        })
      );
  }

  reGenerateInvoice(data: any): Observable<any> {
    return this.httpClient.post<any>(this.common.getApiAddress() + "/customerinvoices/ReGenerateInvoice", data)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Generating Invoice failed due to an issue", e);
        })
      );
  }

  createAccountingInvoice(data: any): Observable<any> {
    return this.httpClient.post<any>(this.common.getApiAddress() + "/customerinvoices/CreateAccountingInvoice", data)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Generating Quickbooks invoice failed due to an issue", e);
        })
      );
  }

  verifyAccountingToken(): Observable<any> {
    return this.httpClient.get<any>(this.common.getApiAddress() + "/quickbooks/IsTokenValid")
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Unable to validate Quickbooks token, please generate a token in QBO by authorization or contact administrator", e);
        })
      );
  }

  sendInvoice(data: any): Observable<any> {
    return this.httpClient.post<any>(this.common.getApiAddress() + "/customerinvoices/SendInvoice", data)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Sending Invoice got failed due to an issue", e);
        })
      );
  }

  update(data: Customerinvoices): Observable<Customerinvoices> {
    return this.httpClient.put<Customerinvoices>(this.common.getApiAddress() + "/customerinvoices/" + data.id.toString(), data)
      .pipe(
        map<Customerinvoices, Customerinvoices>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Updating customer Invoice failed", e);
        })
      );
  }

  delete(id: number): Observable<Customerinvoices> {
    return this.httpClient.delete<Customerinvoices>(this.common.getApiAddress() + "/customerinvoices/" + id.toString())
      .pipe(
        map<Customerinvoices, Customerinvoices>(r => {
          return r;
        }),
        catchError(e => {
          //debugger;
          return this.common.handleError("Delete Customer Invoice failed", e);
        })
      );
  }
}
